import { safeStorage } from '@/shared/services/storage.service'

const STORAGE_KEY = 'wallets:withdrawToCard'

function saveWithdrawToCardParamsToStorage(params) {
  if (typeof params !== 'object' || params === null) {
    throw new TypeError(
      'saveWithdrawToCardParamsToStorage expects a non-null object'
    )
  }
  safeStorage.setItem(STORAGE_KEY, params)
}

function getWithdrawToCardParamsFromStorage() {
  return safeStorage.getItem(STORAGE_KEY)
}

export { saveWithdrawToCardParamsToStorage, getWithdrawToCardParamsFromStorage }
